import React, { useEffect, useRef, useState } from 'react'
import { apibaseURl, errorToast, loggedInCustomerDetails, showValidationErrors } from '../functions/Function';
import Designitem from "../components/web/Designitem";
import Rangslideritem from "../components/web/Rangslideritem";
import Designitemagnet from '../components/web/Designitemagnet ';
import StepSix from './Order/Orderform/StepSix';
import StepSeven from './Order/Orderform/StepSeven';
import Matte from "../assets/web/images/Matte.png";
import sticker_grafic from "../assets/img/grafics/Sticker Graphic.jpg";
import magnet_grafic from "../assets/img/grafics/Magnet Graphic.png";
import kisskat from "../assets/img/grafics/Artboard 1@4x.png";
import hangtag from "../assets/img/grafics/Artboard 2@4x.png";
import ThroughCut from "../assets/img/grafics/Artboard 3@4x.png";
import designnumber from "../assets/img/grafics/Artboard 4@4x.png";
import customlogo from "../assets/img/grafics/Artboard 5@4x.png";
import Glossy from "../assets/web/images/Glossy.png";
import USA from "../assets/img/grafics/Artboard 7@4x.png";
import PrePriced from "../assets/img/grafics/Artboard 8@4x.png";
import Barcodeset from "../assets/img/grafics/Artboard 6@4x.png";
import magenet_dispalyimg from "../assets/img/grafics/magnet_dispaly.jpg";
import SidedMetalFloor2 from "../assets/web/images/4 Sided Metal Counter - HT.jpg";
import SidedMetalFloor5 from "../assets/web/images/4 Sided Counter - Light.jpg";
import SidedMetalFloor1 from "../assets/web/images/4 Sided Metal Floor - HT.jpg";
import AdditionalChargeRow from '../components/web/AdditionalChargeRow';


const Home2 = (props) => {
    const [selectedQty, setselectedQty] = useState(25);
    const [checkedQty, setcheckedQty] = useState("Yes");
    const [percentage, setpercentage] = useState(0);
    const [validationAlert, setvalidationAlert] = useState("");
    const [selectedSize, setselectedSize] = useState("Small");
    const [checkedSize, setcheckedSize] = useState("Yes");
    const [origins, setOrigins] = useState([]);
    const [open, setOpen] = useState(false);
    const [inputs, setInputs] = useState({
        user_id: loggedInCustomerDetails("id"),
        order_origin: "",
        reorder: "No",
        delivery_type: "asready",
        company_name: "",
        buyer_email: "",
        buyer_name: "",
        buyer_phone: "",
        delivery_date: "",
        artapproval_date: "",
        terms: "",
        shipping_type: [],
        usps_shipping_address: "",
        usps_billing_address: "",
        usps_billing_address_type: "No",
        fedex_shipping_address: null,
        finish: "Matte",
        cutstyle: "Kisscut",
        designnumber: "Yes",
        madeinusa: "Yes",
        magnet_madeinusa: "Yes",
        sticker_retailprices: "No",
        magnet_retailprices: "No",
        sticker_retailprices_value: "",
        magnet_retailprices_value: "",
        customlogo: "No",
        barcode: "Yes",
        PriceNeed: "No",
        price: 0.0,
        other: "",
        requested_name_drop: "",
        order_type: "",
        order_type_magnet: "",
        displaytype: "",
        display_types: [
            {
                id: 1,
                display_type_metal: "four_side_metal_counter",
                label: "4 Sided Metal Counter",
                qty: 0,
                display_type_metal_price: 2460.0,
                price_label: "2,460",
            },
            {
                id: 2,
                display_type_metal: "four_side_metal_floor",
                label: "4 Sided Metal Floor",
                qty: 0,
                display_type_metal_price: 8450.0,
                price_label: "8,450",
            },
            {
                id: 3,
                display_type_metal: "four_side_wood_counter",
                label: "4 Sided Metal Floor Narrow",
                qty: 0,
                display_type_metal_price: 5900.0,
                price_label: "5,900",
            },

        ],
        displaytype_magnet_option: "",
        display_types_magnet: [
            {
                id: 1,
                display_type_metal: "Magnet Narrow Floor Rack",
                label: "Magnet Narrow Floor Rack",
                qty: 0,
                display_type_metal_price: 3040.0,
                price_label: "3,040",
            },
        ],
        category: [
            { keyword: "", percentage: 0 },
            { keyword: "", percentage: 0 },
            { keyword: "", percentage: 0 },
            { keyword: "", percentage: 0 },
            { keyword: "", percentage: 0 },
            { keyword: "", percentage: 0 },
            { keyword: "", percentage: 0 },
            { keyword: "", percentage: 0 },
            { keyword: "", percentage: 0 },
            { keyword: "", percentage: 0 },
        ],
        display: [
            {
                size: "Small",
                qty: "0",
                design_number: "",
                customization: "",
                price: 0,
            },
            {
                size: "Small",
                qty: "0",
                design_number: "",
                customization: "",
                price: 0,
            },
            {
                size: "Small",
                qty: "0",
                design_number: "",
                customization: "",
                price: 0,
            },
            {
                size: "Small",
                qty: "0",
                design_number: "",
                customization: "",
                price: 0,
            },
            {
                size: "Small",
                qty: "0",
                design_number: "",
                customization: "",
                price: 0,
            },
        ],
        display_magnet: [
            {
                size: "Small",
                qty: "0",
                design_number: "",
                customization: "",
                magnet_size_type: "Wood",
                price: 0,
            },
            {
                size: "Small",
                qty: "0",
                design_number: "",
                customization: "",
                magnet_size_type: "Wood",
                price: 0,
            },
            {
                size: "Small",
                qty: "0",
                design_number: "",
                customization: "",
                magnet_size_type: "Wood",
                price: 0,
            },
            {
                size: "Small",
                qty: "0",
                design_number: "",
                customization: "",
                magnet_size_type: "Wood",
                price: 0,
            },
            {
                size: "Small",
                qty: "0",
                design_number: "",
                customization: "",
                magnet_size_type: "Wood",
                price: 0,
            },
        ],
        additional_charges: [
            {
                description: "",
                price: "",
                qty: "",
                total: "",
            }
        ],
        note: "",
        discount: 0,
        discount_percentage: 0,
        additional_note: "",
        terms_and_conditions: "",
        total: 0.0,
        override_total: 0.0,
        signature: "",
        files: [],
    });
    const [errors, setErrors] = useState({});
    const DEFAULT_DISPLAY_TYPES = [
        {
            id: 1,
            display_type_metal: "four_side_metal_counter",
            label: "4 Sided Metal Counter",
            qty: 0,
            display_type_metal_price: 2460.0,
            price_label: "2,460",
        },
        {
            id: 2,
            display_type_metal: "four_side_metal_floor",
            label: "4 Sided Metal Floor",
            qty: 0,
            display_type_metal_price: 8450.0,
            price_label: "8,450",
        },
        {
            id: 3,
            display_type_metal: "four_side_wood_counter",
            label: "4 Sided Metal Floor Narrow",
            qty: 0,
            display_type_metal_price: 5900.0,
            price_label: "5,900",
        },
    ];
    const DEFAULT_DISPLAY_TYPES_FOR_MAGNET = [
        {
            id: 1,
            display_type_metal: "Magnet Narrow Floor Rack",
            label: "Magnet Narrow Floor Rack",
            qty: 0,
            display_type_metal_price: 3040.0,
            price_label: "3,040",
        },
    ]
    const DEFAULT_DISPLAY_magnet = [
        {
            size: "Small",
            qty: "0",
            design_number: "",
            customization: "",
            magnet_size_type: "Wood",
            price: 0,
        },
        {
            size: "Small",
            qty: "0",
            design_number: "",
            customization: "",
            magnet_size_type: "Wood",
            price: 0,
        },
        {
            size: "Small",
            qty: "0",
            design_number: "",
            customization: "",
            magnet_size_type: "Wood",
            price: 0,
        },
        {
            size: "Small",
            qty: "0",
            design_number: "",
            customization: "",
            magnet_size_type: "Wood",
            price: 0,
        },
        {
            size: "Small",
            qty: "0",
            design_number: "",
            customization: "",
            magnet_size_type: "Wood",
            price: 0,
        },
    ]
    const DEFAULT_DISPLAY = [
        {
            size: "Small",
            qty: "0",
            design_number: "",
            customization: "",
            price: 0,
        },
        {
            size: "Small",
            qty: "0",
            design_number: "",
            customization: "",
            price: 0,
        },
        {
            size: "Small",
            qty: "0",
            design_number: "",
            customization: "",
            price: 0,
        },
        {
            size: "Small",
            qty: "0",
            design_number: "",
            customization: "",
            price: 0,
        },
        {
            size: "Small",
            qty: "0",
            design_number: "",
            customization: "",
            price: 0,
        },
    ]


    // valiadtion function call here ===================.
    const validateOrderForm = (inputs) => {
        const isReorder = inputs.reorder === "Yes";
        const requiredFields = isReorder
            ? [
                { key: "order_origin", label: "Order Origin" },
                { key: "buyer_name", label: "Buyer Name" },
            ]
            : [
                { key: "order_origin", label: "Order Origin" },
                { key: "company_name", label: "Company Name" },
                { key: "buyer_email", label: "Buyer Email" },
                { key: "buyer_name", label: "Buyer Name" },
                { key: "terms", label: "Terms" },
                { key: "shipping_type", label: "Shipping Type" },
                { key: "usps_shipping_address", label: "USPS Shipping Address" },
            ];

        let tempErrors = {};

        requiredFields.forEach((field) => {
            const value = String(inputs[field.key] || "").trim();
            if (!value) {
                tempErrors[field.key] = `${field.label} is required`;
            }

            // ✅ Special check for email
            if (field.key === "buyer_email" && value) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(value)) {
                    tempErrors[field.key] = "Please enter a valid email address";
                }
            }
        });

        setErrors(tempErrors);

        return Object.keys(tempErrors).length === 0;
    };


    // valiadtion function call here ===================.
    const checkbox = useRef();
    const handleShippingTypeChange = (type) => {
        setInputs((prev) => {
            const isAlreadySelected = prev.shipping_type.includes(type);
            let updatedTypes = [];
            if (isAlreadySelected) {
                updatedTypes = prev.shipping_type.filter((item) => item !== type);
            } else {
                updatedTypes = [...prev.shipping_type, type];
            }
            return {
                ...prev,
                shipping_type: updatedTypes,
            };
        });
    };

    // origion list here ========================>
    const fetchOrigins = () => {
        fetch(apibaseURl + "origins")
            .then((res) => res.json())
            .then((result) => {
                if (result.status == true) {
                    setOrigins(result.response);
                }
            });
    };
    useEffect(() => {
        fetchOrigins();
    }, [props]);

    // state  one function call here  here  ======================================================
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs((values) => ({ ...values, [name]: value }));
    };
    const updateReorderInput = async (e) => {
        if (inputs.reorder == "No") {
            setInputs((values) => ({ ...values, reorder: "Yes" }));
            setInputs((values) => ({ ...values, order_type: "" }));

        } else {
            setInputs((values) => ({ ...values, reorder: "No" }));

            setInputs((values) => ({ ...values, order_type: "" }));

        }

    };
    useEffect(() => {
        if (inputs.order_type_magnet === "Stickers" || inputs.order_type_magnet === "Magnets") {
            validateOrderForm(inputs)
            if (inputs.reorder === "Yes") {
                validateOrderForm(inputs)
            }
        }
    }, [inputs.reorder, inputs.order_type_magnet, inputs.order_type])

    const updateDate = (e) => {
        setInputs((values) => ({ ...values, delivery_date: e.target.value }));
        setInputs((values) => ({ ...values, delivery_type: "" }));
    };

    const updateasready = (e) => {
        setInputs((values) => ({ ...values, delivery_type: "asready" }));
        setInputs((values) => ({ ...values, delivery_date: "" }));
    };
    const updateasap = (e) => {
        setInputs((values) => ({ ...values, delivery_date: "" }));
        setInputs((values) => ({ ...values, delivery_type: "asap" }));
    };

    const updateAddressType = () => {
        setInputs((values) => {
            const prevType = values.usps_billing_address_type;
            const newType = prevType === "Yes" ? "No" : "Yes";

            return {
                ...values,
                usps_billing_address_type: newType,
                usps_billing_address: newType === "Yes"
                    ? values.usps_shipping_address
                    : ""
            };
        });
    };


    const updateShippingAddress = (newShippingAddress) => {
        setInputs((values) => ({
            ...values,
            usps_shipping_address: newShippingAddress,
            usps_billing_address:
                values.usps_billing_address_type === "Yes"
                    ? newShippingAddress
                    : values.usps_billing_address
        }));
    };

    const handleClick = () => {
        if (checkbox.current.checked) {
            setInputs((values) => ({
                ...values,
                fedex_shipping_address: inputs.usps_shipping_address,
            }));
        } else {
            setInputs((values) => ({ ...values, fedex_shipping_address: "" }));
        }
    };
    // state Two function call here  here  ======================================================
    const updatefinish = (value) => {
        setInputs((values) => ({ ...values, finish: value }));
    };
    const updatefinishcutStyle = (value) => {
        setInputs((values) => ({ ...values, cutstyle: value }));
    };

    const updatefinishtypedata = (e) => {
        const { name, value } = e.target;
        setInputs((prevInputs) => ({
            ...prevInputs,
            [name]: value,
        }));
    };
    // state eight function call here  here  ======================================================
    // magnet row delete here call 
    const addmore = () => {
        for (let i = 0; i < 5; i++) {
            let row = {
                size: "Small",
                qty: 0,
                design_number: "",
                customization: "",
                price: 0,
            };
            let dispplaynew = inputs.display;
            dispplaynew[dispplaynew.length] = row;
            setInputs((values) => ({ ...values, display: dispplaynew }));
        }
    };

    // magnet row delete here call 
    const addmoreMagnet = () => {
        for (let i = 0; i < 5; i++) {
            let row = {
                size: "Small",
                qty: 0,
                design_number: "",
                customization: "",
                magnet_size_type: "",
                price: 0,
            };
            let dispplaynew = inputs.display_magnet;
            dispplaynew[dispplaynew.length] = row;
            setInputs((values) => ({ ...values, display_magnet: dispplaynew }));
        }
    };
    const deleteRow = (index) => {
        const updatedDisplay = inputs.display_magnet.filter((_, i) => i !== index);
        setInputs((values) => ({ ...values, display_magnet: updatedDisplay }));
    };

    // magnet row delete here call 

    const generateOptions = () => {
        const options = [];
        options.push(<option value={0}>-</option>);
        for (let i = 25; i <= 2500; i += 25) {
            options.push(
                <option key={i} value={i}>
                    {i}
                </option>
            );
        }
        return options;
    };

    const handleChangeqty = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setselectedQty(value);
        if (checkedQty == "Yes") {
            fillqtyAllFields(value);
        }
    };

    const checkedQtyCheckbox = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        if (value == "Yes") {
            setselectedQty("");
            setcheckedQty("No");
        } else {
            setcheckedQty("Yes");
            fillqtyAllFields(selectedQty);
        }
    };

    const fillqtyAllFields = (qty) => {
        const updatedQty = inputs.display.map((item) => ({
            ...item,
            qty: qty,
        }));
        setInputs((values) => ({ ...values, display: updatedQty }));
    };

    const handleChangeSize = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setselectedSize(value);
        if (checkedSize == "Yes") {
            fillsizeAllFields(value);
        }
    };

    const checkedSizeCheckbox = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        if (value == "Yes") {
            setselectedSize("");
            setcheckedSize("No");
        } else {
            setcheckedSize("Yes");
            fillsizeAllFields(selectedQty);
        }
    };

    const fillsizeAllFields = (size) => {
        const updatedSize = inputs.display.map((item) => ({
            ...item,
            size: size,
        }));
        setInputs((values) => ({ ...values, display: updatedSize }));
    };

    //  range slider call here ================>
    const updatepercentage = () => {
        let totalpercentage = 0;
        {
            inputs.category.map(function (object, i) {
                totalpercentage = Number(totalpercentage) + Number(object.percentage);
            });
        }
        setpercentage(totalpercentage);
    };
    // fourth step 
    const handleChangeqtychange2 = (event, id) => {
        const qty = parseFloat(event.target.value) || 0;
        const updatedDisplayTypes = inputs.display_types.map((item) =>
            item.id === id ? { ...item, qty } : item
        );
        setInputs((values) => ({ ...values, display_types: updatedDisplayTypes }));
    };

    const handleChangeqtychangeFormagnetDisplay = (event, id) => {
        const qty = parseFloat(event.target.value) || 0;
        const updatedDisplayTypes = inputs.display_types_magnet.map((item) =>
            item.id === id ? { ...item, qty } : item
        );
        setInputs((values) => ({ ...values, display_types_magnet: updatedDisplayTypes }));
    };
    // Step six code call here 

    useEffect(() => {
        console.log("updateinputs", props.updateinputs)
        if (props.updateorderId > 0) {
            setInputs(props.updateinputs);
        }
    }, [props.updateinputs]);


    // baki validation check krenke liye 
    const isAtLeastOneQtyValid = () => {
        return inputs.display_types.some(item => parseInt(item.qty) > 0);
    };

    const isAtLeastOneQtyValidformagnet = () => {
        return inputs.display_types_magnet.some(item => parseInt(item.qty) > 0);
    };
    const isCategoryPercentageValid = () => {
        const total = inputs.category.reduce((sum, item) => {
            return sum + parseFloat(item.percentage || 0);
        }, 0);
        return total === 100;
    };

    const handleCreateOrder = () => {
        const { order_type, displaytype, order_type_magnet, displaytype_magnet_option } = inputs;
        const isStickerOrMagnet = order_type === "Stickers" || order_type_magnet === "Magnets";
        const isMagnetOrder = order_type_magnet === "Magnets";
        const isKeywordOrDesign = displaytype === "display_by_keyword";
        const isKeywordOrDesignfordispalydesign = displaytype === "display_design";
        const iskeywordformagnetdisplaytype = displaytype_magnet_option === "display_design";
        if (isStickerOrMagnet && isKeywordOrDesign) {
            if (!isAtLeastOneQtyValid()) {
                errorToast("Please enter quantity for at least one display type.");
                return false;
            }
            if (!isCategoryPercentageValid()) {
                errorToast("Total percentage of keywords must be exactly 100%.");
                return false;
            }
        } else if (isStickerOrMagnet && isKeywordOrDesignfordispalydesign) {
            if (!isAtLeastOneQtyValid()) {
                errorToast("Please enter quantity for at least one display type.");
                return false;
            }
        } else if (isMagnetOrder && iskeywordformagnetdisplaytype) {
            if (!isAtLeastOneQtyValidformagnet()) {
                errorToast("Please enter quantity for at least one display type.");
                return false;
            }
        }
        return true;
    };

    const handleOrderChange = (value) => {
        const isValid = validateOrderForm(inputs);
        if (!isValid) return;
        setInputs((prev) => {
            if (value === "Stickers") {
                const isSame = prev.order_type === value;
                return {
                    ...prev,
                    order_type: isSame ? "" : value,
                    display_types: isSame
                        ? [...DEFAULT_DISPLAY_TYPES]  // अगर unselect कर दिया तो reset
                        : [...prev.display_types],
                };
            } else if (value === "Magnets") {
                const isSame = prev.order_type_magnet === value;
                return {
                    ...prev,
                    order_type_magnet: isSame ? "" : value,         // Toggle ON/OFF
                    display_magnet: isSame
                        ? [...DEFAULT_DISPLAY_magnet]                // अगर OFF किया तो reset
                        : [...prev.display_magnet],                  // वरना जैसा है वैसा रहने दो
                };
            }
            return prev;
        });
    };


    const handleDisplayTypeChange = (value) => {
        setInputs((prev) => {
            const isSame = prev.displaytype === value;
            if (isSame) {
                // दोबारा select किया → reset defaults
                return {
                    ...prev,
                    displaytype: "",
                    display_types: [...DEFAULT_DISPLAY_TYPES],
                };
            }
            // पहली बार select किया → बस set करो
            return {
                ...prev,
                displaytype: value,
            };
        });
    };

    const handleDisplayTypeChangeformagnet = (value) => {
        setInputs((prev) => {
            const isSame = prev.displaytype_magnet_option === value;
            if (isSame) {
                // दोबारा select किया → reset defaults
                return {
                    ...prev,
                    displaytype_magnet_option: "",
                    display_types_magnet: [...DEFAULT_DISPLAY_TYPES_FOR_MAGNET],
                };
            }
            // पहली बार select किया → बस set करो
            return {
                ...prev,
                displaytype_magnet_option: value,
                display_types_magnet: [...DEFAULT_DISPLAY_TYPES_FOR_MAGNET],
            };
        });
    };


    useEffect(() => {
        if (inputs.order_type_magnet == "" && inputs.order_type == "") {
            setInputs((values) => ({
                ...values,
                total: 0,

            }));
        } else if (inputs.order_type == "") {
            setInputs((values) => ({
                ...values,
                displaytype: "",
                display_types: [...DEFAULT_DISPLAY_TYPES],
                display: [...DEFAULT_DISPLAY],
            }));
        }
    }, [inputs.order_type_magnet, inputs.order_type])


    const addmoreCharges = () => {
        setInputs((prev) => ({
            ...prev,
            additional_charges: [
                ...prev.additional_charges,
                { description: "", price: 0, qty: 0, total: 0 }
            ]
        }));
    };
    const deleteRowforAdditioanlcharges = (index) => {
        setInputs((values) => {
            if (values.additional_charges.length === 1) {
                return values; 
            }
            const updatedDisplay = values.additional_charges.filter((_, i) => i !== index);
            return {
                ...values,
                additional_charges: updatedDisplay
            };
        });
    };

    console.log("inputs",inputs)
    return (

        <>
            <section className="section registratio-box" style={{ paddingBottom: "250px" }}>
                <div className="container">
                    {/* // first step code call here =============================> */}
                    <div className="form-box box-shadow">
                        <div className="mb-3 form-input-box">
                            <label className="form-label">Order Origin</label>
                            <span className="form-star">
                                <i className="fa-solid fa-star"></i>
                            </span>
                            <div className="form-input-box ">
                                <select
                                    name="order_origin"
                                    className="form-control"
                                    value={inputs.order_origin || ""}
                                    onChange={handleChange}>
                                    <option value={""}>Select Order Origin</option>
                                    {origins.length > 0 &&
                                        origins.map((row, i) => (
                                            <option value={row.title} key={row.id}>
                                                {row.title}
                                            </option>
                                        ))}
                                </select>
                                <div className="form-icon">
                                    <i className="fa-solid fa-building"></i>
                                </div>

                            </div>
                            {errors.order_origin && (
                                <div className="form-text text-danger">
                                    {errors.order_origin}
                                </div>
                            )}
                        </div>
                        <div className="mb-3 form-input-box">
                            <div className="form-check check-box align-items-center d-flex">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="reorder"
                                    value="Yes"
                                    checked={inputs.reorder === "Yes"}
                                    onClick={updateReorderInput}
                                    id="flexRadioDefault3"
                                />
                                <label className="form-check-label" htmlFor="flexRadioDefault3">
                                    <small>Current Client</small>
                                </label>
                            </div>
                        </div>

                        <div className="mb-3 form-input-box">
                            <label className="form-label">Buyer Name</label>
                            <span className="form-star">
                                <i className="fa-solid fa-star"></i>
                            </span>
                            <div className="form-input-box">
                                <input
                                    type="text"
                                    name="buyer_name"
                                    value={inputs.buyer_name || ""}
                                    onChange={handleChange}
                                    placeholder="Buyer Name"
                                    className="form-control"
                                />
                                <div className="form-icon">
                                    <i className="fa-solid fa-building"></i>
                                </div>
                            </div>
                            {errors.buyer_name && (
                                <div className="form-text text-danger">
                                    {errors.buyer_name}
                                </div>
                            )}
                        </div>

                        <div className="mb-3 form-input-box">
                            <label className="form-label">Company Name</label>
                            {inputs.reorder === "Yes" ? (
                                <span></span>
                            ) : (
                                <span className="form-star">
                                    <i className="fa-solid fa-star"></i>
                                </span>
                            )}
                            <div className="form-input-box">
                                <input
                                    type="text"
                                    name="company_name"
                                    value={inputs.company_name || ""}
                                    onChange={handleChange}
                                    placeholder="Company Name"
                                    className="form-control"
                                />
                                <div className="form-icon">
                                    <i className="fa-solid fa-building"></i>
                                </div>
                            </div>
                            {errors.company_name && (
                                <div className="form-text text-danger">
                                    {errors.company_name}
                                </div>
                            )}
                        </div>

                        <div className="mb-3 form-input-box">
                            <label className="form-label">Buyer Email</label>
                            {inputs.reorder === "Yes" ? (
                                <span></span>
                            ) : (
                                <span className="form-star">
                                    <i className="fa-solid fa-star"></i>
                                </span>
                            )}
                            <div className="form-input-box">
                                <input
                                    type="text"
                                    name="buyer_email"
                                    value={inputs.buyer_email || ""}
                                    onChange={handleChange}
                                    placeholder="Buyer Email"
                                    className="form-control"
                                />
                                <div className="form-icon">
                                    <i className="fa-solid fa-envelope"></i>
                                </div>
                            </div>
                            {errors.buyer_email && (
                                <div className="form-text text-danger">
                                    {errors.buyer_email}
                                </div>
                            )}
                        </div>
                        <div className="mb-3 form-input-box">
                            <label className="form-label">Buyer Phone Number</label>
                            <div className="form-input-box">
                                <input
                                    type="tel"
                                    name="buyer_phone"
                                    value={inputs.buyer_phone || ""}
                                    onChange={handleChange}
                                    placeholder="Buyer Phone Number"
                                    className="form-control"
                                />
                                <div className="form-icon">
                                    <i className="fa-solid fa-phone-flip"></i>
                                </div>
                            </div>
                        </div>
                        <div className=" mb-3 dilivrydateflex">
                            <div className="w-100">
                                <div className="form-input-box">
                                    <label className="form-label">Art Completion Date</label>
                                    <div className="form-input-box">
                                        <input
                                            type="date"
                                            name="artapproval_date"
                                            value={inputs.artapproval_date || ""}
                                            onChange={handleChange}
                                            placeholder="YYYY-MM-DD"
                                            className="form-control"
                                        />
                                        <div className="form-icon">
                                            <i className="fa-solid fa-calendar-days"></i>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                        <div className=" mb-3 dilivrydateflex">
                            <div className="w-100">
                                <div className="form-input-box">
                                    <label className="form-label">Ship Date</label>
                                    <div className="form-input-box">
                                        <input
                                            type="date"
                                            name="delivery_date"
                                            value={inputs.delivery_date || ""}
                                            onChange={updateDate}
                                            placeholder="YYYY-MM-DD"
                                            className="form-control"
                                        />
                                        <div className="form-icon">
                                            <i className="fa-solid fa-calendar-days"></i>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                        <div className=" mb-3 dilivrydateflex">
                            <div className="w-100">
                                <div className="asreadycheckbox d-flex ">
                                    <div className=" form-input-box asreadycheckboxitem">
                                        <div className="form-check check-box align-items-center d-flex">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="delivery_type"
                                                value="asready"
                                                checked={inputs.delivery_type === "asready"}
                                                onClick={updateasready}
                                                id="flexRadioDefault4"
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="flexRadioDefault4"
                                            >
                                                <small>As Ready (within 1 month)</small>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-input-box asreadycheckboxitem">
                                        <div className="form-check check-box align-items-center d-flex">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="delivery_type"
                                                value="asap"
                                                checked={inputs.delivery_type === "asap"}
                                                onClick={updateasap}
                                                id="flexRadioDefault7"
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="flexRadioDefault7"
                                            >
                                                <small>ASAP - Rush (2-3 weeks ,CC for 10% down needed)</small>
                                            </label><br />

                                        </div>
                                        <div>
                                            {inputs.delivery_type === "asap" && (
                                                <p className="text-danger">10% Due at order submission</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mb-3 ">
                            <label className="form-label">Terms</label>
                            {inputs.reorder === "Yes" ? (
                                <span></span>
                            ) : (
                                <span className="form-star">
                                    <i className="fa-solid fa-star"></i>
                                </span>
                            )}
                            <div className="form-input-box">
                                <input
                                    type="text"
                                    name="terms"
                                    value={inputs.terms || ""}
                                    onChange={handleChange}
                                    placeholder="Terms"
                                    className="form-control"
                                />
                                <div className="form-icon">
                                    <i className="fa-solid fa-file-pen"></i>
                                </div>
                            </div>
                            {errors.terms && (
                                <div className="form-text text-danger">
                                    {errors.terms}
                                </div>
                            )}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Shipping Type</label>
                            {inputs.reorder === "Yes" ? (
                                <span></span>
                            ) : (
                                <span className="form-star">
                                    <i className="fa-solid fa-star"></i>
                                </span>
                            )}

                            <div className="form-input-box d-flex flex-wrap flex-md-nowrap">
                                {["UPS", "FEDEX", "USPS"].map((type, index) => (
                                    <div
                                        key={index}
                                        className="form-check check-box align-items-center d-flex me-3 mb-2"

                                    >
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="shipping_type"
                                            value={type}
                                            checked={inputs.shipping_type.includes(type)}
                                            onChange={() => handleShippingTypeChange(type)}
                                            id={`option${index + 1}`}
                                        />
                                        <label
                                            className="form-check-label ms-2"

                                        >
                                            <small>{type}</small>
                                        </label>
                                    </div>
                                ))}
                            </div>

                            {errors.shipping_type && (
                                <div className="form-text text-danger">
                                    {errors.shipping_type}
                                </div>
                            )}
                        </div>


                        <div className="mb-3 form-input-box heading-text-field">
                            <label className="form-label">Shipping Address</label>
                            {inputs.reorder === "Yes" ? (
                                <span></span>
                            ) : (
                                <span className="form-star">
                                    <i className="fa-solid fa-star"></i>
                                </span>
                            )}

                            <br />

                            <div className="form-input-box mt-3">
                                <textarea
                                    className="form-control height-100"
                                    placeholder="USPS Shipping Address"

                                    value={inputs.usps_shipping_address}
                                    onChange={(e) => updateShippingAddress(e.target.value)}
                                ></textarea>

                                <div className="form-icon">
                                    <i className="fa-sharp fa-solid fa-location-dot"></i>
                                </div>
                            </div>
                            {errors.usps_shipping_address && (
                                <div className="form-text text-danger">
                                    {errors.usps_shipping_address}
                                </div>
                            )}
                        </div>
                        <div className="mb-3 form-input-box heading-text-field">

                            <input
                                className="form-check-input"
                                type="radio"
                                name="usps_billing_address_type"
                                value="Yes"
                                checked={inputs.usps_billing_address_type === "Yes"}
                                onClick={updateAddressType}
                                id="flexRadioDefault7"
                            />
                            <label className="form-label">Shipping and Billing Address both are same</label>
                        </div>
                        {inputs.usps_billing_address_type != "Yes" && (
                            <div className="mb-3 form-input-box heading-text-field">
                                <label className="form-label">Billing Address</label>
                                <div className="form-input-box mt-3">
                                    <textarea
                                        className="form-control height-100"
                                        placeholder="Billing Address"
                                        name="usps_billing_address"
                                        value={inputs.usps_billing_address || ""}
                                        onChange={handleChange}
                                    ></textarea>

                                    <div className="form-icon">
                                        <i className="fa-sharp fa-solid fa-location-dot"></i>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="mb-3 form-input-box heading-text-field">
                            <div className="check-box d-flex">
                                <input
                                    type="hidden"
                                    name="addresssame"
                                    ref={checkbox}
                                    id="sameAddress"
                                    onChange={handleClick}
                                />
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">What would you like to order?</label>
                            <span className="form-star">
                                <i className="fa-solid fa-star"></i>
                            </span>
                            <div className="form-input-box d-flex justify-content-between">

                                <div className="form-check check-box align-items-center d-flex me-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="order_type"
                                        value={inputs.order_type}
                                        checked={inputs.order_type === "Stickers"}
                                        onChange={() => handleOrderChange("Stickers")}
                                    />
                                    <label className="form-check-label ms-2" >
                                        <small>Stickers</small>
                                    </label>
                                </div>

                                <div className="form-check check-box align-items-center d-flex me-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="order_type_magnet"
                                        value={inputs.order_type_magnet}
                                        checked={inputs.order_type_magnet === "Magnets"}
                                        onChange={() => handleOrderChange("Magnets")}
                                    />
                                    <label className="form-check-label ms-2" >
                                        <small>Magnets</small>
                                    </label>
                                </div>

                            </div>
                        </div>

                        {/* // second step code call here =============================> */}
                        {inputs.order_type === "Stickers" && (
                            <>
                                <div className='row border border-5 mb-3 border-secondary'>
                                    <div className='col-md-12 mt-2'>
                                        <div className="img_box_wrapper">
                                            <img className="img-fluid" src={sticker_grafic} alt="" />
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <div className="mt-4">
                                            <div className='row'>
                                                <div className='col-md-12 mb-3'>
                                                    <h2 className="form-heading">Finish Type</h2>
                                                    <div className="row">
                                                        <div className="col-lg-6 col-sm-6 col-6">
                                                            <div
                                                                className={`display-box ${inputs.finish == "Matte" && "active"
                                                                    }`}
                                                                onClick={() => updatefinish("Matte")}
                                                            >
                                                                <div className="display-box-heading">Matte</div>
                                                                <div className="img-box">
                                                                    <img className="img-fluid" src={Matte} alt="" />
                                                                </div>
                                                                <div>
                                                                    <button type="submit" className="btn site-btn">
                                                                        {" "}
                                                                        {inputs.finish == "Matte" ? "SELECTED" : "SELECT"}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-sm-6 col-6 text-end">
                                                            <div
                                                                className={`display-box ${inputs.finish == "Glossy" && "active"
                                                                    }`}
                                                                onClick={() => updatefinish("Glossy")}
                                                            >
                                                                <div className="display-box-heading">Glossy</div>
                                                                <div className="img-box">
                                                                    <img className="img-fluid" src={Glossy} alt="" />
                                                                </div>
                                                                <div>
                                                                    <button type="submit" className="btn site-btn">
                                                                        {inputs.finish == "Glossy" ? "SELECTED" : "SELECT"}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-12 mb-3'>
                                                    <h2 className="form-heading">Cut Style</h2>

                                                    <div className="row">
                                                        <div className="col-lg-4 col-sm-12 col-12">
                                                            <div
                                                                className={`display-box ${inputs.cutstyle == "Kisscut" && "active"
                                                                    }`}
                                                                onClick={() => updatefinishcutStyle("Kisscut")}
                                                            >
                                                                <div className="display-box-heading">Kisscut</div>
                                                                <div className="img-box">
                                                                    <img className="img-fluid" src={kisskat} alt="" />
                                                                </div>
                                                                <div>
                                                                    <button type="submit" className="btn site-btn">
                                                                        {" "}
                                                                        {inputs.cutstyle == "Kisscut" ? "SELECTED" : "SELECT"}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-sm-12 col-12">
                                                            <div
                                                                className={`display-box ${inputs.cutstyle == "HangTag" && "active"
                                                                    }`}
                                                                onClick={() => updatefinishcutStyle("HangTag")}
                                                            >
                                                                <div className="display-box-heading">HangTag</div>
                                                                <div className="img-box">
                                                                    <img className="img-fluid" src={hangtag} alt="" />
                                                                </div>
                                                                <div>
                                                                    <button type="submit" className="btn site-btn">
                                                                        {" "}
                                                                        {inputs.cutstyle == "HangTag" ? "SELECTED" : "SELECT"}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-4 col-sm-12 col-12">
                                                            <div
                                                                className={`display-box ${inputs.cutstyle == "ThroughCut" && "active"
                                                                    }`}
                                                                onClick={() => updatefinishcutStyle("ThroughCut")}
                                                            >
                                                                <div className="display-box-heading">ThroughCut</div>
                                                                <div className="img-box">
                                                                    <img className="img-fluid" src={ThroughCut} alt="" />
                                                                </div>
                                                                <div>
                                                                    <button type="submit" className="btn site-btn">
                                                                        {" "}
                                                                        {inputs.cutstyle == "ThroughCut" ? "SELECTED" : "SELECT"}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-12 inner-display-box mt-5">
                                                <div className="row inner-display-box-checks mt-3">
                                                    <div className="col-lg-12 col-sm-12 col-12 mb-3">
                                                        <h2 className="form-heading">Design Number</h2>
                                                        <div className="display-chek-box">
                                                            <div className='row'>
                                                                <div className="col-lg-6 col-sm-12 col-12">
                                                                    <div className="display-box ">
                                                                        <div className="img-box">
                                                                            <img className="img-fluid" src={designnumber} alt="" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-6'>
                                                                    <div className="mt-2">
                                                                        {["Yes", "No"].map((val, i) => (
                                                                            <div className="form-check check-box" key={i}>
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="designnumber"
                                                                                    value={val}
                                                                                    checked={inputs.designnumber === val}
                                                                                    onChange={updatefinishtypedata}
                                                                                    id={`designnumber${i}`}
                                                                                />
                                                                                <label className="form-check-label" htmlFor={`designnumber${i}`}>
                                                                                    {val}
                                                                                </label>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    {/* Made in USA */}
                                                    <div className="col-lg-12 col-sm-12 col-12 mb-3">
                                                        <h2 className="form-heading">MADE IN THE USA</h2>
                                                        <div className="display-chek-box">
                                                            <div className='row'>
                                                                <div className="col-lg-6 col-sm-12 col-12">
                                                                    <div className="display-box ">
                                                                        <div className="img-box">
                                                                            <img className="img-fluid" src={USA} alt="" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-6 col-sm-12 col-12">
                                                                    <div className="mt-2">
                                                                        {["Yes", "No"].map((val, i) => (
                                                                            <div className="form-check check-box" key={i}>
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="madeinusa"
                                                                                    value={val}
                                                                                    checked={inputs.madeinusa === val}
                                                                                    onChange={updatefinishtypedata}
                                                                                    id={`madeinusa${i}`}
                                                                                />
                                                                                <label className="form-check-label" htmlFor={`madeinusa${i}`}>
                                                                                    {val}
                                                                                </label>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    {/* Price */}
                                                    <div className="col-lg-12 col-sm-12 col-12 mb-3">
                                                        <h2 className="form-heading">Price* (Need to write down retail prices)</h2>
                                                        <div className="display-chek-box">
                                                            <div className='row'>
                                                                <div className="col-lg-6 col-sm-12 col-12">
                                                                    <div className="display-box ">
                                                                        <div className="img-box">
                                                                            <img className="img-fluid" src={PrePriced} alt="" />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-6 col-sm-12 col-12">
                                                                    <div className="mt-2">
                                                                        {["Yes", "No"].map((val, i) => (
                                                                            <div className="form-check check-box" key={i}>
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="sticker_retailprices"
                                                                                    value={val}
                                                                                    checked={inputs.sticker_retailprices === val}
                                                                                    onChange={updatefinishtypedata}
                                                                                    id={`sticker_retailprices${i}`}
                                                                                />
                                                                                <label className="form-check-label" htmlFor={`sticker_retailprices${i}`}>
                                                                                    {val}
                                                                                </label>
                                                                            </div>
                                                                        ))}

                                                                        {inputs.sticker_retailprices === "Yes" && (
                                                                            <div className="mt-2 form-input-box">
                                                                                <h2 className="form-heading">IF YES, What prices? (Write in Large and Small pricing)</h2>
                                                                                <input
                                                                                    type="text"
                                                                                    name="sticker_retailprices_value"
                                                                                    value={inputs.sticker_retailprices_value || ""}
                                                                                    onChange={handleChange}
                                                                                    placeholder="Price"
                                                                                    className="form-control"
                                                                                />

                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    {/* Custom Logo */}
                                                    <div className="col-lg-12 col-sm-12 col-12 mb-3">
                                                        <h2 className="form-heading">Custom Logo ($0.10 extra per)</h2>
                                                        <div className="display-chek-box">
                                                            <div className='row'>
                                                                <div className='col-md-6'>
                                                                    <div className="display-box">
                                                                        <div className="img-box">
                                                                            <img className="img-fluid" src={customlogo} alt="" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-6'>
                                                                    <div className="mt-2">
                                                                        {["Yes", "No"].map((val, i) => (
                                                                            <div className="form-check check-box" key={i}>
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="customlogo"
                                                                                    value={val}
                                                                                    checked={inputs.customlogo === val}
                                                                                    onChange={updatefinishtypedata}
                                                                                    id={`customlogo${i}`}
                                                                                />
                                                                                <label className="form-check-label" htmlFor={`customlogo${i}`}>
                                                                                    {val}
                                                                                </label>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <div className="mb-3 form-input-box ">
                                            <label className="form-label">Requested Name Drop</label>
                                            <span className="form-star"></span>
                                            <div className="form-input-box">
                                                <textarea
                                                    className="form-control height-100"
                                                    placeholder="Requested Name Drop"
                                                    name="requested_name_drop"
                                                    style={{ height: "30px" }}
                                                    value={inputs.requested_name_drop || ""}
                                                    onChange={handleChange}
                                                ></textarea>
                                                <div className="form-icon">
                                                    <i className="fa-sharp fa-solid fa-location-dot"></i>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                    <div className='col-md-12'>
                                        <div className="mb-3">
                                            <label className="form-label">Choose your sticker order method</label>
                                            <span className="form-star">
                                                <i className="fa-solid fa-star"></i>
                                            </span>
                                            <div className="form-input-box">
                                                <div className="row">
                                                    <div className="col-lg-4 col-sm-6 col-12 mb-2">
                                                        <div className="form-check check-box align-items-center d-flex">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="displaytype"
                                                                value="display_by_keyword"
                                                                checked={inputs.displaytype === "display_by_keyword"}
                                                                onChange={() => handleDisplayTypeChange("display_by_keyword")}
                                                                id="option1"
                                                            />
                                                            <label className="form-check-label ms-2" >
                                                                <small>Display by Keyword </small>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-sm-6 col-12 mb-2">
                                                        <div className="form-check check-box align-items-center d-flex">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="displaytype"
                                                                value="display_design"
                                                                checked={inputs.displaytype === "display_design"}
                                                                onChange={() => handleDisplayTypeChange("display_design")}
                                                                id="option2"
                                                            />
                                                            <label className="form-check-label ms-2">
                                                                <small> Display By Design </small>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-sm-6 col-12 mb-2">
                                                        <div className="form-check check-box align-items-center d-flex">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="displaytype"
                                                                value="Sticker_only"
                                                                checked={inputs.displaytype === "Sticker_only"}
                                                                onChange={() => handleDisplayTypeChange("Sticker_only")}
                                                                id="option2"
                                                            />
                                                            <label className="form-check-label ms-2">
                                                                <small> Sticker Only</small>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>


                                            {inputs.displaytype == "display_by_keyword" && (
                                                <>

                                                    <div className="row mt-3 p-3">
                                                        <div className="col-lg-6 col-sm-6 col-12 inner-display-box">
                                                            <div className="display-box">
                                                                <div className="img-box">
                                                                    <img className="img-fluid" src={SidedMetalFloor2} />
                                                                </div>
                                                            </div>
                                                            <div className="single-description-box  m-0">
                                                                <h5>{inputs.display_types[0].label}</h5>
                                                                <span className="design-price">
                                                                    (${inputs.display_types[0].price_label})
                                                                </span>
                                                                <div className="d-flex">

                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="QTY"
                                                                        value={inputs.display_types[0].qty}
                                                                        onChange={(event) =>
                                                                            handleChangeqtychange2(event, inputs.display_types[0].id)
                                                                        }
                                                                        min={0}
                                                                    />

                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-6 col-sm-6 col-12 inner-display-box text-end">
                                                            <div className="display-box ">
                                                                <div className="img-box">
                                                                    <img className="img-fluid" src={SidedMetalFloor1} />
                                                                </div>
                                                            </div>
                                                            <div className="single-description-box">
                                                                <h5>{inputs.display_types[1].label}</h5>
                                                                <span className="design-price">
                                                                    (${inputs.display_types[1].price_label})
                                                                </span>

                                                                <input
                                                                    type="number"
                                                                    value={inputs.display_types[1].qty}
                                                                    className="form-control"
                                                                    onChange={(event) =>
                                                                        handleChangeqtychange2(event, inputs.display_types[1].id)
                                                                    }
                                                                    min={0}
                                                                    placeholder="QTY"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-6 col-sm-6 col-12 inner-display-box">
                                                            <div className="display-box ">
                                                                <div className="img-box">
                                                                    <img className="img-fluid" src={SidedMetalFloor5} />
                                                                </div>
                                                            </div>
                                                            <div className="single-description-box m-0">
                                                                <h5>{inputs.display_types[2].label}</h5>
                                                                <span className="design-price">
                                                                    (${inputs.display_types[2].price_label})
                                                                </span>
                                                                <form action="">
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="QTY"
                                                                        value={inputs.display_types[2].qty}
                                                                        onChange={(event) =>
                                                                            handleChangeqtychange2(event, inputs.display_types[2].id)
                                                                        }
                                                                        min={0}
                                                                    />
                                                                </form>
                                                            </div>
                                                        </div>

                                                    </div>


                                                    <div className="col-lg-12  inner-display-box-checks progress-bar-box mt-3">
                                                        <div className="row">
                                                            <div className="col-lg-12 col-sm-12 ">
                                                                <div className="text-center">
                                                                    <h5>
                                                                        Please enter the keywords and give an approximate
                                                                        percentage of how much of that category you would like to
                                                                        see on the order
                                                                    </h5>
                                                                </div>
                                                                <div className="text-right">
                                                                    <span className="totalPercentage">
                                                                        Total : {percentage}%
                                                                    </span>
                                                                </div>
                                                                <div className="input-digits-box mt-4 overflow">
                                                                    {inputs.category.map(function (data, i) {
                                                                        return (
                                                                            <Rangslideritem
                                                                                key={i}
                                                                                id={`range_${i}`}
                                                                                data={data}
                                                                                currentValue={data.percentage}
                                                                                index={i}
                                                                                inputs={inputs}
                                                                                setInputs={setInputs}
                                                                                percentage={percentage}
                                                                                updatepercentage={updatepercentage}
                                                                            />
                                                                        );
                                                                    })}

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                            {inputs.displaytype == "display_design" && (
                                                <>

                                                    <div className="row">
                                                        <div className="col-lg-12  inner-display-box-checks">
                                                            <div className="row">
                                                                <div className="col-lg-6 col-sm-6 col-12 inner-display-box">
                                                                    <div className="display-box">
                                                                        <div className="img-box">
                                                                            <img className="img-fluid" src={SidedMetalFloor2} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="single-description-box  m-0">
                                                                        <h5>{inputs.display_types[0].label}</h5>
                                                                        <span className="design-price">
                                                                            (${inputs.display_types[0].price_label})
                                                                        </span>
                                                                        <div className="d-flex">

                                                                            <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                placeholder="QTY"
                                                                                value={inputs.display_types[0].qty}
                                                                                onChange={(event) =>
                                                                                    handleChangeqtychange2(event, inputs.display_types[0].id)
                                                                                }
                                                                                min={0}
                                                                            />

                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-6 col-sm-6 col-12 inner-display-box text-end">
                                                                    <div className="display-box ">
                                                                        <div className="img-box">
                                                                            <img className="img-fluid" src={SidedMetalFloor1} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="single-description-box">
                                                                        <h5>{inputs.display_types[1].label}</h5>
                                                                        <span className="design-price">
                                                                            (${inputs.display_types[1].price_label})
                                                                        </span>

                                                                        <input
                                                                            type="number"
                                                                            value={inputs.display_types[1].qty}
                                                                            className="form-control"
                                                                            onChange={(event) =>
                                                                                handleChangeqtychange2(event, inputs.display_types[1].id)
                                                                            }
                                                                            min={0}
                                                                            placeholder="QTY"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-6 col-sm-6 col-12 inner-display-box">
                                                                    <div className="display-box ">
                                                                        <div className="img-box">
                                                                            <img className="img-fluid" src={SidedMetalFloor5} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="single-description-box m-0">
                                                                        <h5>{inputs.display_types[2].label}</h5>
                                                                        <span className="design-price">
                                                                            (${inputs.display_types[2].price_label})
                                                                        </span>
                                                                        <form action="">
                                                                            <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                placeholder="QTY"
                                                                                value={inputs.display_types[2].qty}
                                                                                onChange={(event) =>
                                                                                    handleChangeqtychange2(event, inputs.display_types[2].id)
                                                                                }
                                                                                min={0}
                                                                            />
                                                                        </form>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                        </div>
                                                        <div className="col-lg-12 col-sm-12 ">
                                                            <div className="input-digits-box mt-4 overflow">
                                                                <div className="row g-3 align-items-center mb-3">
                                                                    <div className="col-lg-12">
                                                                        <div className="row">
                                                                            <div className="col-12 col-sm-6 col-md-6 col-lg-3 mb-2">
                                                                                <div className="input-digits-heading d-flex">
                                                                                    <div className="form-check check-box termsbox">
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="radio"
                                                                                            name="terms_and_conditions"
                                                                                            value={checkedSize}
                                                                                            checked={checkedSize === "Yes"}
                                                                                            onClick={checkedSizeCheckbox}
                                                                                        />
                                                                                    </div>
                                                                                    <select
                                                                                        className="form-select form-control"
                                                                                        id="floatingSelectGrid"
                                                                                        aria-label="Floating label select example"
                                                                                        defaultValue="Size"
                                                                                        name="size"
                                                                                        value={selectedSize}
                                                                                        onChange={handleChangeSize}
                                                                                    >
                                                                                        <option selected value="">
                                                                                            Size
                                                                                        </option>
                                                                                        <option value="Large">Large</option>
                                                                                        <option value="Small">Small</option>
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-12 col-sm-6 col-md-6 col-lg-3 mb-2">
                                                                                <div className="input-digits-heading d-flex">
                                                                                    <div className="form-check check-box termsbox">
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="radio"
                                                                                            name=""
                                                                                            value={checkedQty}
                                                                                            checked={checkedQty === "Yes"}
                                                                                            onClick={checkedQtyCheckbox}
                                                                                        />
                                                                                    </div>
                                                                                    <select
                                                                                        className="form-select form-control"
                                                                                        aria-label="Floating label select example"
                                                                                        defaultValue="50"
                                                                                        name="size"
                                                                                        value={selectedQty}
                                                                                        onChange={handleChangeqty}
                                                                                    >
                                                                                        {generateOptions()}
                                                                                    </select>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                    <div className="table-responsive mt-3">
                                                                        <table className="table table-bordered align-middle">
                                                                            <thead className="table-light text-center">
                                                                                <tr>
                                                                                    <th>#</th>
                                                                                    <th>Size</th>
                                                                                    <th>Quantity</th>
                                                                                    <th>Design Number</th>
                                                                                    <th>Customization</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {inputs.display.map(function (data, i) {
                                                                                    return (
                                                                                        <Designitem
                                                                                            key={i}
                                                                                            id={`design_${i}`}
                                                                                            data={data}
                                                                                            index={i}
                                                                                            inputs={inputs}
                                                                                            setInputs={setInputs}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>

                                                                </div>
                                                                <div className="addmorebtn">
                                                                    <button
                                                                        className="btn btn-sm btn-success"
                                                                        onClick={() => addmore()}
                                                                    >
                                                                        Add More <i className="fa-solid fa-plus"></i>{" "}
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>


                                                </>
                                            )}


                                            {inputs.displaytype == "Sticker_only" && (
                                                <>
                                                    <div className="row">
                                                        <div className="col-lg-12 col-sm-12 ">
                                                            <div className="input-digits-box mt-4 overflow">
                                                                <div className="row g-3 align-items-center mb-3">
                                                                    <div className="col-lg-12">
                                                                        <div className="row">
                                                                            <div className="col-12 col-sm-6 col-md-6 col-lg-3 mb-2">
                                                                                <div className="input-digits-heading d-flex">
                                                                                    <div className="form-check check-box termsbox">
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="radio"
                                                                                            name="terms_and_conditions"
                                                                                            value={checkedSize}
                                                                                            checked={checkedSize === "Yes"}
                                                                                            onClick={checkedSizeCheckbox}
                                                                                        />
                                                                                    </div>
                                                                                    <select
                                                                                        className="form-select form-control"
                                                                                        id="floatingSelectGrid"
                                                                                        aria-label="Floating label select example"
                                                                                        defaultValue="Size"
                                                                                        name="size"
                                                                                        value={selectedSize}
                                                                                        onChange={handleChangeSize}
                                                                                    >
                                                                                        <option selected value="">
                                                                                            Size
                                                                                        </option>
                                                                                        <option value="Large">Large</option>
                                                                                        <option value="Small">Small</option>
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-12 col-sm-6 col-md-6 col-lg-3 mb-2">
                                                                                <div className="input-digits-heading d-flex">
                                                                                    <div className="form-check check-box termsbox">
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="radio"
                                                                                            name=""
                                                                                            value={checkedQty}
                                                                                            checked={checkedQty === "Yes"}
                                                                                            onClick={checkedQtyCheckbox}
                                                                                        />
                                                                                    </div>
                                                                                    <select
                                                                                        className="form-select form-control"
                                                                                        aria-label="Floating label select example"
                                                                                        defaultValue="50"
                                                                                        name="size"
                                                                                        value={selectedQty}
                                                                                        onChange={handleChangeqty}
                                                                                    >
                                                                                        {generateOptions()}
                                                                                    </select>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                    <div className="table-responsive mt-3">
                                                                        <table className="table table-bordered align-middle">
                                                                            <thead className="table-light text-center">
                                                                                <tr>
                                                                                    <th>#</th>
                                                                                    <th>Size</th>
                                                                                    <th>Quantity</th>
                                                                                    <th>Design Number</th>
                                                                                    <th>Customization</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {inputs.display.map(function (data, i) {
                                                                                    return (
                                                                                        <Designitem
                                                                                            key={i}
                                                                                            id={`design_${i}`}
                                                                                            data={data}
                                                                                            index={i}
                                                                                            inputs={inputs}
                                                                                            setInputs={setInputs}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>

                                                                </div>
                                                                <div className="addmorebtn">
                                                                    <button
                                                                        className="btn btn-sm btn-success"
                                                                        onClick={() => addmore()}
                                                                    >
                                                                        Add More <i className="fa-solid fa-plus"></i>{" "}
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>

                                                </>
                                            )}




                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {inputs.order_type_magnet === "Magnets" && (
                            <>
                                <div className='row border border-5 border-secondary'>
                                    <div className='col-md-12 mt-2'>
                                        <div className="img_box_wrapper">
                                            <img className="img-fluid" src={magnet_grafic} alt="" />
                                        </div>
                                    </div>
                                    <div className="mt-5">
                                        <div className="col-lg-12 inner-display-box">

                                            <div className="row">
                                                <div className="col-lg-12 inner-display-box inner-display-box-checks mt-3">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-sm-12 col-12 mt-2">
                                                            <div className="display-chek-box">

                                                                <h2 className="form-heading">Barcode ($0.10 extra per)</h2>
                                                                <div className='row'>
                                                                    <div className='col-md-6'>
                                                                        <div className="display-box">
                                                                            <div className="img-box">
                                                                                <img className="img-fluid" src={Barcodeset} alt="" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-6'>
                                                                        <div className='mt-2'>
                                                                            <div className="form-check check-box">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="barcode"
                                                                                    value="Yes"
                                                                                    checked={inputs.barcode === "Yes"}
                                                                                    onChange={updatefinishtypedata}
                                                                                    id="flexRadioDefault7"
                                                                                />
                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="flexRadioDefault7"
                                                                                >
                                                                                    Yes
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-check check-box">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="barcode"
                                                                                    value="No"
                                                                                    checked={inputs.barcode === "No"}
                                                                                    onChange={updatefinishtypedata}
                                                                                    id="flexRadioDefault8"
                                                                                />
                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="flexRadioDefault8"
                                                                                >
                                                                                    No
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                        <div className="col-lg-12 col-sm-12 col-12 mt-2">
                                                            <div className="display-chek-box">
                                                                <h2 className="form-heading">MADE IN THE USA</h2>
                                                                <div className='row'>
                                                                    <div className='col-md-6'>
                                                                        <div className="display-box">
                                                                            <div className="img-box">
                                                                                <img className="img-fluid" src={USA} alt="" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-6'>
                                                                        <div className='mt-2'>
                                                                            <div className="form-check check-box">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="magnet_madeinusa"
                                                                                    value="Yes"
                                                                                    checked={inputs.magnet_madeinusa === "Yes"}
                                                                                    onChange={updatefinishtypedata}
                                                                                    id="flexRadioDefault7"
                                                                                />
                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="flexRadioDefault7"
                                                                                >
                                                                                    Yes
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-check check-box">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="radio"
                                                                                    name="magnet_madeinusa"
                                                                                    value="No"
                                                                                    checked={inputs.magnet_madeinusa === "No"}
                                                                                    onChange={updatefinishtypedata}
                                                                                    id="flexRadioDefault8"
                                                                                />
                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor="flexRadioDefault8"
                                                                                >
                                                                                    No
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                        <div className="col-lg-12 col-sm-12 col-12 mt-2">
                                                            <div className="display-chek-box">
                                                                <h2 className="form-heading">Price* (Need to write down retail prices)</h2>
                                                                <div className='row'>
                                                                    <div className='col-md-6'>
                                                                        <div className="display-box">
                                                                            <div className="img-box">
                                                                                <img className="img-fluid" src={PrePriced} alt="" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-6'>
                                                                        <div className="mt-2">
                                                                            {["Yes", "No"].map((val, i) => (
                                                                                <div className="form-check check-box" key={i}>
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="radio"
                                                                                        name="magnet_retailprices"
                                                                                        value={val}
                                                                                        checked={inputs.magnet_retailprices === val}
                                                                                        onChange={updatefinishtypedata}
                                                                                        id={`magnet_retailprices${i}`}
                                                                                    />
                                                                                    <label className="form-check-label" htmlFor={`magnet_retailprices${i}`}>
                                                                                        {val}
                                                                                    </label>
                                                                                </div>
                                                                            ))}

                                                                            {inputs.magnet_retailprices === "Yes" && (
                                                                                <div className="mt-2 form-input-box">
                                                                                    <label className="form-label">
                                                                                        IF YES, What prices? (Write in Large and Small pricing)
                                                                                    </label>
                                                                                    <input
                                                                                        type="text"
                                                                                        name="magnet_retailprices_value"
                                                                                        value={inputs.magnet_retailprices_value || ""}
                                                                                        onChange={handleChange}
                                                                                        placeholder="Price"
                                                                                        className="form-control"
                                                                                    />

                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>



                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">

                                        <div className="col-lg-12 col-sm-12">
                                            <div className="row">

                                                <div className="col-lg-6 col-sm-6 col-12 mb-2">
                                                    <div className="form-check check-box align-items-center d-flex">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="displaytype_magnet_option"
                                                            value="display_design"
                                                            checked={inputs.displaytype_magnet_option === "display_design"}
                                                            onChange={() => handleDisplayTypeChangeformagnet("display_design")}
                                                            id="option2"
                                                        />
                                                        <label className="form-check-label ms-2" htmlFor="option2">
                                                            <small> Display By Design </small>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-sm-6 col-12 mb-2">
                                                    <div className="form-check check-box align-items-center d-flex">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="displaytype_magnet_option"
                                                            value="Magnet_only"
                                                            checked={inputs.displaytype_magnet_option === "Magnet_only"}
                                                            onChange={() => handleDisplayTypeChangeformagnet("Magnet_only")}
                                                            id="option2"
                                                        />
                                                        <label className="form-check-label ms-2" htmlFor="option2">
                                                            <small> Magnet Only</small>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {inputs.displaytype_magnet_option === "display_design" &&
                                            <div className="row mt-3 p-3">
                                                <div className="col-lg-6 col-sm-6 col-12 inner-display-box">
                                                    <div className="display-box">
                                                        <div className="img-box">
                                                            <img className="img-fluid" src={magenet_dispalyimg} />
                                                        </div>
                                                    </div>
                                                    <div className="single-description-box  m-0">
                                                        <h5>{inputs.display_types_magnet[0].label}</h5>
                                                        <span className="design-price">
                                                            (${inputs.display_types_magnet[0].price_label})
                                                        </span>
                                                        <div className="d-flex">

                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder="QTY"
                                                                value={inputs.display_types_magnet[0].qty}
                                                                onChange={(event) =>
                                                                    handleChangeqtychangeFormagnetDisplay(event, inputs.display_types_magnet[0].id)
                                                                }
                                                                min={0}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                                   <div className="col-lg-12 col-sm-12">
                                                <div className="input-digits-box mt-4 overflow">
                                                    <div className="row g-3 align-items-center mb-3">
                                                        <div className="col-lg-12">
                                                            <div className="row">
                                                                <div className="col-12 col-sm-6 col-md-6 col-lg-3 mb-2">
                                                                    <div className="input-digits-heading d-flex">
                                                                        <div className="form-check check-box termsbox me-2">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="radio"
                                                                                name="checkedSize"
                                                                                value={checkedSize}
                                                                                checked={checkedSize === "Yes"}
                                                                                onClick={checkedSizeCheckbox}
                                                                            />
                                                                        </div>
                                                                        <select
                                                                            className="form-select"
                                                                            name="size"
                                                                            value={selectedSize}
                                                                            onChange={handleChangeSize}
                                                                        >
                                                                            <option value="">Size</option>
                                                                            <option value="Large">Large</option>
                                                                            <option value="Small">Small</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-sm-6 col-md-6 col-lg-3 mb-2">
                                                                    <div className="input-digits-heading d-flex">
                                                                        <div className="form-check check-box termsbox me-2">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="radio"
                                                                                value={checkedQty}
                                                                                checked={checkedQty === "Yes"}
                                                                                onClick={checkedQtyCheckbox}
                                                                            />
                                                                        </div>
                                                                        <select
                                                                            className="form-select"
                                                                            value={selectedQty}
                                                                            onChange={handleChangeqty}
                                                                        >
                                                                            {generateOptions()}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="table-responsive mt-3">
                                                            <table className="table table-bordered align-middle">
                                                                <thead className="table-light text-center">
                                                                    <tr>
                                                                        <th>#</th>
                                                                        <th>Size</th>
                                                                        <th>Finish</th>
                                                                        <th>Quantity</th>
                                                                        <th>Design Number</th>
                                                                        <th>Customization</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {inputs.display_magnet.map((data, i) => (
                                                                        <Designitemagnet
                                                                            key={i}
                                                                            index={i}
                                                                            data={data}
                                                                            inputs={inputs}
                                                                            setInputs={setInputs}
                                                                            deleteRow={deleteRow}
                                                                        />
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>

                                                    {/* Add More Button */}
                                                    <div className="addmorebtn mt-3">
                                                        <button
                                                            className="btn btn-sm btn-success"
                                                            onClick={() => addmoreMagnet()}
                                                        >
                                                            Add More <i className="fa-solid fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                        }
                                        {inputs.displaytype_magnet_option === "Magnet_only" &&
                                            <div className="col-lg-12 col-sm-12">
                                                <div className="input-digits-box mt-4 overflow">
                                                    <div className="row g-3 align-items-center mb-3">
                                                        <div className="col-lg-12">
                                                            <div className="row">
                                                                <div className="col-12 col-sm-6 col-md-6 col-lg-3 mb-2">
                                                                    <div className="input-digits-heading d-flex">
                                                                        <div className="form-check check-box termsbox me-2">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="radio"
                                                                                name="checkedSize"
                                                                                value={checkedSize}
                                                                                checked={checkedSize === "Yes"}
                                                                                onClick={checkedSizeCheckbox}
                                                                            />
                                                                        </div>
                                                                        <select
                                                                            className="form-select"
                                                                            name="size"
                                                                            value={selectedSize}
                                                                            onChange={handleChangeSize}
                                                                        >
                                                                            <option value="">Size</option>
                                                                            <option value="Large">Large</option>
                                                                            <option value="Small">Small</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-sm-6 col-md-6 col-lg-3 mb-2">
                                                                    <div className="input-digits-heading d-flex">
                                                                        <div className="form-check check-box termsbox me-2">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="radio"
                                                                                value={checkedQty}
                                                                                checked={checkedQty === "Yes"}
                                                                                onClick={checkedQtyCheckbox}
                                                                            />
                                                                        </div>
                                                                        <select
                                                                            className="form-select"
                                                                            value={selectedQty}
                                                                            onChange={handleChangeqty}
                                                                        >
                                                                            {generateOptions()}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="table-responsive mt-3">
                                                            <table className="table table-bordered align-middle">
                                                                <thead className="table-light text-center">
                                                                    <tr>
                                                                        <th>#</th>
                                                                        <th>Size</th>
                                                                        <th>Finish</th>
                                                                        <th>Quantity</th>
                                                                        <th>Design Number</th>
                                                                        <th>Customization</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {inputs.display_magnet.map((data, i) => (
                                                                        <Designitemagnet
                                                                            key={i}
                                                                            index={i}
                                                                            data={data}
                                                                            inputs={inputs}
                                                                            setInputs={setInputs}
                                                                            deleteRow={deleteRow}
                                                                        />
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>

                                                    {/* Add More Button */}
                                                    <div className="addmorebtn mt-3">
                                                        <button
                                                            className="btn btn-sm btn-success"
                                                            onClick={() => addmoreMagnet()}
                                                        >
                                                            Add More <i className="fa-solid fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                    </div>
                                </div>
                            </>
                        )}



                        {/* // Third  step code call here =============================> */}
                        {(inputs.order_type === "Stickers" || inputs.order_type_magnet === "Magnets") && (
                            (inputs.displaytype || inputs.order_type_magnet === "Magnets") && (
                                <>
                                    {inputs.additional_charges.length > 0 ?
                                        <div className='row border border-5 border-secondary mt-3 pt-3'>
                                            <h3>Additional Charges</h3>
                                            <div className="table-responsive mt-3">
                                                <table className="table table-bordered align-middle">
                                                    <thead className="table-light text-center">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Charge Description </th>
                                                            <th>Price</th>
                                                            <th>Quantity</th>
                                                            <th>Total</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {inputs.additional_charges.map((data, i) => (
                                                            <AdditionalChargeRow
                                                                key={i}
                                                                index={i}
                                                                data={data}
                                                                inputs={inputs}
                                                                setInputs={setInputs}
                                                                deleteRowforAdditioanlcharges={deleteRowforAdditioanlcharges}
                                                            />
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="addmorebtn mt-3">
                                                <button
                                                    className="btn btn-sm btn-success"
                                                    onClick={() => addmoreCharges()}
                                                >
                                                    Add More <i className="fa-solid fa-plus"></i>
                                                </button>
                                            </div>
                                        </div>
                                        : ""}
                                    <StepSix inputs={inputs} setInputs={setInputs} />
                                    <StepSeven inputs={inputs} setInputs={setInputs} handleCreateOrder={handleCreateOrder} props={props} />
                                </>
                            )
                        )}

                    </div>
                </div>
            </section>
        </>

    )
}

export default Home2;





